<template>
    <div :class="$style.wrapper">
        <MobileInitBlock v-if="props.isInitBlockVisible" />
        <SearchResults
            v-else
            :searchResults="props.searchResults"
            :status="props.status"
            :onClick="props.onClick"
        />
    </div>
</template>
<script setup lang="ts">
import type { SearchResults as SearchResultsType, SearchStatusResult } from '../types'
import MobileInitBlock from './MobileInitBlock.vue'
import SearchResults from './SearchResults.vue'

const props = defineProps<{
    searchResults: SearchResultsType | undefined
    status: SearchStatusResult
    isInitBlockVisible: boolean
    onClick: () => void
}>()
</script>
<style module>
.wrapper {
    position: absolute;
    inset: 0;
    z-index: 1;
    background: var(--carbon-100);
    padding: calc(78px + var(--pg-safe-area-top)) calc(var(--pg-safe-area-right) + 6px)
        calc(var(--pg-safe-area-bottom) + 48px) calc(var(--pg-safe-area-left) + 6px);
    overflow-y: auto;
}
</style>
